/* tslint:disable */
/* eslint-disable */
/**
 * fantasy-dynasty-app
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AuctionBid } from '../model';
/**
 * AuctionApi - axios parameter creator
 * @export
 */
export const AuctionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} leagueEventId 
         * @param {AuctionBid} auctionBid A bid to be made on the nominated player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auctionBid: async (leagueEventId: string, auctionBid: AuctionBid, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueEventId' is not null or undefined
            assertParamExists('auctionBid', 'leagueEventId', leagueEventId)
            // verify required parameter 'auctionBid' is not null or undefined
            assertParamExists('auctionBid', 'auctionBid', auctionBid)
            const localVarPath = `/auction/{leagueEventId}/bid`
                .replace(`{${"leagueEventId"}}`, encodeURIComponent(String(leagueEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auctionBid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} body The number of teams in the Auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMock: async (body: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createMock', 'body', body)
            const localVarPath = `/auction/createMock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuctionApi - functional programming interface
 * @export
 */
export const AuctionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuctionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} leagueEventId 
         * @param {AuctionBid} auctionBid A bid to be made on the nominated player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auctionBid(leagueEventId: string, auctionBid: AuctionBid, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auctionBid(leagueEventId, auctionBid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} body The number of teams in the Auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMock(body: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMock(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuctionApi - factory interface
 * @export
 */
export const AuctionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuctionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} leagueEventId 
         * @param {AuctionBid} auctionBid A bid to be made on the nominated player
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auctionBid(leagueEventId: string, auctionBid: AuctionBid, options?: any): AxiosPromise<void> {
            return localVarFp.auctionBid(leagueEventId, auctionBid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} body The number of teams in the Auction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMock(body: number, options?: any): AxiosPromise<string> {
            return localVarFp.createMock(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuctionApi - object-oriented interface
 * @export
 * @class AuctionApi
 * @extends {BaseAPI}
 */
export class AuctionApi extends BaseAPI {
    /**
     * 
     * @param {string} leagueEventId 
     * @param {AuctionBid} auctionBid A bid to be made on the nominated player
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionApi
     */
    public auctionBid(leagueEventId: string, auctionBid: AuctionBid, options?: AxiosRequestConfig) {
        return AuctionApiFp(this.configuration).auctionBid(leagueEventId, auctionBid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} body The number of teams in the Auction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionApi
     */
    public createMock(body: number, options?: AxiosRequestConfig) {
        return AuctionApiFp(this.configuration).createMock(body, options).then((request) => request(this.axios, this.basePath));
    }
}
